module.exports = __webpack_public_path__ + "img/roads.7c35015e.jpg";